import { dayUserLimitUrl, tokensUrl, totalDayLimitUrl, walletConnectUrl, walletGetMessageUrl } from './apiUrls';

export const fetchWalletGetMessage = async (): Promise<string> => {
  const response = await fetch(walletGetMessageUrl, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const message = (await response.json()) as string;
  return message.split(': ')[1];
};

export const fetchWalletConnect = async (address: string, signed_msg: string, message: string): Promise<string> => {
  const response = await fetch(walletConnectUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      address,
      signed_msg,
      message,
    }),
  });
  const res = (await response.json()) as { token: string; wallet_address: string };
  return res.token || '';
};

export const fetchTokens = async (): Promise<string | { detail: 'string' }> => {
  const tokenAddress = localStorage.getItem('tokenAddress');

  if (tokenAddress) {
    const response = await fetch(tokensUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Token ${tokenAddress}`,
      },
    });

    const res = (await response.json()) as string | { detail: 'string' };
    return res;
  } else return '';
};

export const fetchUserDailyLimit = async (tokenAddress: string): Promise<string | { detail: string }> => {
  const response = await fetch(dayUserLimitUrl, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token ${tokenAddress}`,
    },
  });

  const res = await response.json();
  return res;
};

export const fetchTotalDailyLimit = async (tokenAddress: string): Promise<string | { detail: string }> => {
  const response = await fetch(totalDayLimitUrl, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token ${tokenAddress}`,
    },
  });

  const res = await response.json();
  return res;
};
